import type { Group } from '@/group/domain/group';

// Merge two group lists into one list avoiding duplicates (unicity based on elements' id) 
export const mergeLists = (list1: Group[] | any[], list2: Group[]| any[]): any[] => {
    const map = new Map<number, any>();

    list1.forEach(item => {
        if (item.id !== undefined && item.id !== null) {
            map.set(item.id, item);
        }
    });
    list2.forEach(item => {
        if (item.id !== undefined && item.id !== null) {
            map.set(item.id, item);
        }
    });

    return Array.from(map.values());
};